module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10269.f4680e16.jpg";